import React from 'react';
import { Button } from './ui/button';

/** Shown instead of an empty list when a request fails, so "no data" and "couldn't load" never look alike. */
export default function LoadError({ what = 'this page', onRetry }) {
  return (
    <div role="alert" className="p-6 bg-surface border border-contrast/10 rounded-xl text-ink-2 flex items-center justify-between gap-4 flex-wrap">
      <span>We couldn't load {what}. Check your connection and try again.</span>
      {onRetry && <Button variant="outline" onClick={onRetry}>Retry</Button>}
    </div>
  );
}
